import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b9e0099c33a19326b8165990727f4d26.png';

const navLinks = [
  { label: 'Hizmetler', href: '/#hizmetler' },
  { label: 'Hakkında', href: '/#hakkinda' },
  { label: 'Blog', href: '/#blog' },
  { label: 'Randevu', href: '/#randevu' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isServicePage = location.pathname !== '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    if (href.startsWith('/#')) {
      const id = href.replace('/#', '');
      if (location.pathname !== '/') {
        window.location.href = href;
      } else {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const navBg = isServicePage || scrolled
    ? 'bg-cream shadow-sm border-b border-cream-deeper'
    : 'bg-transparent';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20 md:h-24">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img src={LOGO_URL} alt="Ayşegül Sert Logo" className="h-16 md:h-20 w-auto object-contain" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-warm-mid hover:text-warm-dark text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA Desktop */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick('/#randevu')}
            className="px-5 py-2.5 bg-gold text-white text-sm font-medium rounded-full hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            Randevu Al
          </button>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menü"
        >
          <i className={`text-warm-dark text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-cream border-t border-cream-deeper px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-left text-warm-mid text-sm font-medium py-2 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('/#randevu')}
            className="mt-2 px-5 py-2.5 bg-gold text-white text-sm font-medium rounded-full cursor-pointer whitespace-nowrap text-center"
          >
            Randevu Al
          </button>
        </div>
      )}
    </header>
  );
}